import React from "react";
import styled from "styled-components";
// @ts-ignore
import classNames from 'classnames';
// @ts-ignore
import * as countries from 'iso-3166-1-codes';

import Barchart from "../Barchart/Barchart";
import Props from "./Props";

const Wrapper = styled.div`
  color: white;
  overflow: hidden;

  & h4 {
    font-size: 1.91625rem;
    font-family: Mapfre-Black;
  }

  &.is-life h4 {
    color: white;
  }

  &.is-no-life h4 {
    color: #737373;
  }

  .tier-barchart__wrapper {
    min-width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;

    & svg {
      min-width: 100%;
      overflow-y: hidden;
      pointer-events: none;
    }
  }
`;

const TierBarchart = ({ tier, records, isLife }: Props) => {
  const maxGip = Math.max(...records.map(country => country.gip));
  const firstPageLength = 5;
  const displayDataCountries = records.sort((a, b) => (b.gip - a.gip));

  return (
    <Wrapper id={ `tier-${ tier }-barchart` } className={ classNames({ 'is-life': isLife, 'is-no-life': !isLife }) }>
      <h4>Tier { tier }</h4>
      <div className="tier-barchart__wrapper">
        <Barchart
          countries={ displayDataCountries }
          maxGip={ maxGip }
          firstPageLength={ firstPageLength }
          isLife={ isLife }
        />
      </div>
    </Wrapper>
  )
};

export default TierBarchart;
